var map = {
	"./en-US/app.json": "pheF",
	"./en-US/callPopScreen.json": "/aKv",
	"./en-US/common.json": "O4ey",
	"./en-US/header.json": "/PwN",
	"./en-US/home.json": "eFS9",
	"./en-US/menu.json": "Rl0G",
	"./en-US/mixins.json": "JCWi",
	"./en-US/qidian.json": "1UjG",
	"./en-US/shortCutMenu.json": "Kpl5",
	"./en-US/tabBar.json": "7xJT",
	"./en-US/utils.json": "+hU7",
	"./en-US/wincall.json": "iWYH",
	"./zh-CN/app.json": "uWjD",
	"./zh-CN/callPopScreen.json": "aFng",
	"./zh-CN/common.json": "BBbc",
	"./zh-CN/header.json": "REa4",
	"./zh-CN/home.json": "M9rm",
	"./zh-CN/menu.json": "7Xr4",
	"./zh-CN/mixins.json": "lKwY",
	"./zh-CN/qidian.json": "bd5n",
	"./zh-CN/shortCutMenu.json": "nWoy",
	"./zh-CN/tabBar.json": "dij0",
	"./zh-CN/utils.json": "ZvLf",
	"./zh-CN/wincall.json": "7Xqm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q2ds";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales [A-Za-z0-9-_,\s]+\.json$/
// module id = Q2ds
// module chunks = 1